import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'

interface DonutDataItem {
  name: string
  value: number
  percentage: number
  color?: string
}

interface AnalyticsDonutChartProps {
  data: DonutDataItem[]
  height?: number
  innerRadius?: number
  outerRadius?: number
  centerLabel?: string
  centerValue?: string | number
}

const COLORS = [
  '#FFD500', '#f59e0b', '#06b6d4', '#10b981', '#f59e0b',
  '#ef4444', '#ec4899', '#6366f1', '#14b8a6', '#f97316'
]

export function AnalyticsDonutChart({
  data,
  height = 200,
  innerRadius = 55,
  outerRadius = 80,
  centerLabel,
  centerValue
}: AnalyticsDonutChartProps) {
  if (data.length === 0) return null

  return (
    <div className="relative" style={{ height }}>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            dataKey="value"
            paddingAngle={2}
            strokeWidth={0}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color || COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: '#0f172a',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 12px',
              fontSize: '12px',
              color: '#fff'
            }}
            formatter={(value: number, name: string) => [`${value} (${data.find(d => d.name === name)?.percentage.toFixed(1)}%)`, name]}
          />
        </PieChart>
      </ResponsiveContainer>
      {centerLabel && centerValue && (
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-xl font-semibold text-framed-neutral-800">{centerValue}</span>
          <span className="text-xs text-framed-neutral-500">{centerLabel}</span>
        </div>
      )}
    </div>
  )
}

export function DonutLegend({ data }: { data: DonutDataItem[] }) {
  return (
    <div className="space-y-2">
      {data.map((item, index) => (
        <div key={item.name} className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: item.color || COLORS[index % COLORS.length] }}
            />
            <span className="text-framed-neutral-600">{item.name}</span>
          </div>
          <span className="text-framed-neutral-800 font-medium">
            {Math.round(item.percentage)}%
          </span>
        </div>
      ))}
    </div>
  )
}
